import { FormikErrors } from 'formik'

export function scrollToFirstError(
  errors: Record<string, any>,
  options?: {
    behavior?: ScrollBehavior
    block?: ScrollLogicalPosition
    inline?: ScrollLogicalPosition
  },
): void {
  if (Object.keys(errors).length === 0) return

  const firstErrorField = Object.keys(errors)[0]
  const errorElement = document.getElementById(firstErrorField)

  if (errorElement) {
    errorElement.scrollIntoView({
      behavior: options?.behavior || 'smooth',
      block: options?.block || 'center',
      inline: options?.inline,
    })
    errorElement.focus()
  }
}

export async function validateForm<T>(
  errors: FormikErrors<T>,
  setTouched: (
    touched: Record<string, boolean>,
    shouldValidate?: boolean,
  ) => void,
): Promise<boolean> {
  const touched: Record<string, boolean> = {}
  Object.keys(errors).forEach((key) => {
    touched[key] = true
  })
  setTouched(touched)

  const hasErrors = Object.keys(errors).length > 0
  if (hasErrors) {
    scrollToFirstError(errors as Record<string, any>)
  }

  return !hasErrors
}
